import { render, staticRenderFns } from "./CreateDocument.vue?vue&type=template&id=d430f266&"
import script from "./CreateDocument.vue?vue&type=script&lang=js&"
export * from "./CreateDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d430f266')) {
      api.createRecord('d430f266', component.options)
    } else {
      api.reload('d430f266', component.options)
    }
    module.hot.accept("./CreateDocument.vue?vue&type=template&id=d430f266&", function () {
      api.rerender('d430f266', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/vistas/CreateDocument.vue"
export default component.exports